// React binding for the device-local favorites set (storage/kvStores.ts, the
// brain's KV-backed KvFavorites — docs/09 §10). Uses useSyncExternalStore so
// every screen showing favorites (Main) and the place they're managed
// (contact detail) stay in sync from one source.

import { useSyncExternalStore } from 'react';
import { getFavorites, subscribeFavorites } from '../../storage/kvStores.js';

export function useFavorites(): readonly string[] {
  return useSyncExternalStore(subscribeFavorites, getFavorites, getFavorites);
}
